export function calculateDaysLeft(targetDate: Date): number {
  const today = new Date();
  const diffTime = targetDate.getTime() - today.getTime();
  return diffTime > 0 ? Math.ceil(diffTime / (1000 * 3600 * 24)) : 0;
}
